<template>
  <label v-bind="$attrs">
    <sg-text regular gray v-if="value" tag="span">{{ value }}</sg-text>
    <sg-text regular gray v-else tag="span"><slot></slot></sg-text>
  </label>
</template>

<script>
export default {
  props: ['value'],
};
</script>
